import { InvoiceData } from "../../types/type";
import { formatCurrency } from "@/utils/utilityFunctions";

export default function InvoiceItems({ invoiceData }: { invoiceData: InvoiceData }) {

    const calculateSubtotal = (items: Array<{ quantity: number; unitPrice: number }>) => {
        return items.reduce((sum, item) => sum + (item.quantity * item.unitPrice), 0);
    };

    return (
        <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="text-sm">
                <div className="grid grid-cols-2 sm:grid-cols-3 font-semibold border-b pb-2 mb-2">
                    <span>Item</span>
                    <span className="hidden sm:block"></span>
                    <span className="text-right">Unit Price</span>
                </div>
                {invoiceData.items.map((item, index) => (
                    <div key={index} className="grid grid-cols-2 sm:grid-cols-3 py-2">
                        <div>
                            <span>{item.name}</span>
                            <div className="text-xs text-gray-500">Qty: {item.quantity}</div>
                        </div>
                        <span className="hidden sm:block"></span>
                        <span className="text-right">{formatCurrency(item.unitPrice)}</span>
                    </div>
                ))}
                <div className="border-t mt-2 pt-2">
                    <div className="flex justify-between font-medium">
                        <span>Subtotal</span>
                        <span className="text-blue-600">{formatCurrency(calculateSubtotal(invoiceData.items))}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}